import React, { memo } from 'react';
import { ArrowRight } from 'lucide-react';
interface CollectionTile {
  title: string;
  description: string;
  href: string;
  image: string;
}
const tiles: CollectionTile[] = [{
  title: 'Cards',
  description: 'Graded rookies, autographed inserts, and vintage classics.',
  href: '#shop',
  image: 'https://cdn.magicpatterns.com/uploads/3bmX1MJcmT5hep3B2FZyTq/IMG_0073.jpg'
}, {
  title: 'Memorabilia',
  description: 'Signed helmets, mini helmets, and Ohio State collectibles.',
  href: '#memorabilia',
  image: 'https://cdn.magicpatterns.com/uploads/9hBEeTERgbU2Gcm7Vypzwq/IMG_0079.jpg'
}];
export const BrowseCollection = () => {
  return <section className="py-16 md:py-24 bg-cream" data-id="element-2">
      <div className="container mx-auto px-4" data-id="element-3">
        <div className="mb-10 text-center" data-id="element-4">
          <h2 className="font-heading text-3xl md:text-4xl text-ink uppercase tracking-wide" data-id="element-5">
            Browse The Collection
          </h2>
          <p className="text-silver font-bold uppercase tracking-wider mt-2 text-sm" data-id="element-6">
            Two ways to dig in
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-7">
          {tiles.map(tile => <a key={tile.title} href={tile.href} className="group relative block overflow-hidden border-4 border-ink shadow-comic hover:shadow-comic-hover hover:translate-x-[4px] hover:translate-y-[4px] transition-all duration-200 min-h-[260px] md:min-h-[340px] bg-ink" data-id="element-8">
              <img src={tile.image} alt={tile.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 opacity-80" data-id="element-9" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/50 to-transparent" data-id="element-10" />
              <div className="relative z-10 h-full flex flex-col justify-end p-8" data-id="element-11">
                <h3 className="font-heading text-4xl md:text-5xl text-white uppercase tracking-wide drop-shadow-[3px_3px_0px_rgba(0,0,0,1)]" data-id="element-12">
                  {tile.title}
                </h3>
                <p className="text-cream mt-2 max-w-sm font-bold drop-shadow-[1px_1px_0px_rgba(0,0,0,1)]" data-id="element-13">
                  {tile.description}
                </p>
                <span className="inline-flex items-center gap-2 text-white font-heading text-xl uppercase tracking-wider mt-4 bg-scarlet w-max px-4 py-2 border-2 border-ink shadow-[3px_3px_0px_0px_#1A1A1A]" data-id="element-14">
                  Explore
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-15" />
                </span>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
};